/**
 * AdmSettingsRisksWidget
 * DUERP module settings tab content
 */

import { connect } from "react-redux"
import { withTranslation, WithTranslation } from "react-i18next"
import { Session } from "@/redux/_session.types"
import EstablishmentConfig from "@/features/adm/entities/establishment/ui/EstablishmentConfig"
import OrganizationScales from "@/features/adm/entities/organization/ui/OrganizationScales"
import OrganizationForm from "@/features/adm/entities/organization/ui/OrganizationForm"
import Card from "@/components/card"
import { t } from "i18next"

interface StateProps extends WithTranslation {
  _session: Session
}

type Props = StateProps

function AdmSettingsRisksWidget(props: Props) {
  const canEditScales =
    props._session.risksInterfaceType === "ESTABLISHMENT" &&
    (props._session.connectedAsSupervisor || props._session.modules.risks?.scales)

  return (
    <>
      <OrganizationForm />
      <EstablishmentConfig />
      {canEditScales && <OrganizationScales />}
      {props._session.risksInterfaceType === "ESTABLISHMENT" && !canEditScales && (
        <Card title={t("Configuration du module DUERP")}>
          <p className="text-sm grey-t">
            {t(
              "La configuration de votre module DUERP (barèmes, attributs, échelles de risque) est réalisée par l'équipe IDTree. Pour toute demande de modification, contactez-nous à"
            )}{" "}
            <a href="mailto:support@id-tree.com" className="underline">
              support@id-tree.com
            </a>
          </p>
        </Card>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(AdmSettingsRisksWidget))
